/*@ngInject*/
const FormRuleBuilderRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.validateRule = function (rule) {
        var url = '/rest/Rule/validate';
        return this.post(url, rule);
    };

};

angular.module('ums.configuration')
    .service('formRuleBuilderRepository', FormRuleBuilderRepository);
